import {
  RECEIVE_INVOICES,
  CREATE_INVOICES,
  REMOVE_INVOICES,
  FILTER_INVOICES
} from '../invoicesActionTypes';

export default function invoices(state = {}, action) {
  switch(action.type) {
    case RECEIVE_INVOICES:
      return action.payload;
    case CREATE_INVOICES:
      return state.concat(action.payload);
    case REMOVE_INVOICES:
      return [];
    case FILTER_INVOICES:
      return filterByStage(action.payload, state);
    default:
      return state;
  }
}

function filterByStage(value, collection) {
  if(value === '') return collection;

  if(value === 'action_required') {
    return collection.filter((item) => { return item.action_required === true; });
  } else {
    return collection.filter((item) => { return item.stage === value; });
  }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/reducers/invoicesReducer.js